// extracted by mini-css-extract-plugin
export const note = "Note-module--note--hSqDI";